export const GUEST_VIEW = `
import React, { useState, useEffect } from 'react';
// THIS WONT GO TO GUESTS
export default function GuestView({ pluginApi, eventId, userId, isLoggedIn }) {
  return (<></>)
}`
